import styled from "styled-components";

import { increaseWidthAnimation } from "@sso/theme/animations";

import { Wrapper } from "./FlexBox";

interface LinearLoadingProps {
  delay?: number;
  color?: string;
}
const IncreaseLine = styled.div<LinearLoadingProps>`
  height: 5px;
  position: absolute;
  background: ${p => p.color || p.theme.colors.primary.main};
  animation: ${increaseWidthAnimation} 3s ${p => p.delay && `${p.delay}s`} infinite;
`;
export const LinearLoading = (props: LinearLoadingProps) => {
  return (
    <Wrapper position="relative" width="100%" height="5px" overflow="hidden">
      <Wrapper position="absolute" opacity={0.5} width="100%" height="5px" />
      <IncreaseLine color={props.color} />
      <IncreaseLine delay={1.5} {...props} />
    </Wrapper>
  );
};
